var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative p-10",staticStyle:{"width":"1123px","height":"1587px"}},[_c('img',{staticClass:"w-full",attrs:{"src":"https://nhsafe.maot.co.kr:8080/storage/app/media/%EB%86%8D%ED%98%91_%EB%B3%B8%EC%82%AC_%EA%B2%BD%EC%98%81%EB%B0%A9%EC%B9%A8.jpg","alt":"bg"}})])
}]

export { render, staticRenderFns }